// extracted by mini-css-extract-plugin
export default {"root":"EmptyState_root__-Ox94","title":"EmptyState_title__ljWUu","description":"EmptyState_description__0ER1h","action":"EmptyState_action__go+14"};